import getOS from '../hooks/getOS';

const getDevicePlatform = () => {
  if (typeof window.ReactNativeWebView === 'undefined') return 'web';
  const os = getOS();
  if (os === 'Android') return 'android';
  if (os === 'iPhone' || os === 'iPad' || os === 'iPod') return 'ios';
  return 'web';
};

export const getCodParticipante = () => {
  try {
    const themeConfig = JSON.parse(localStorage.getItem('themeConfig'));
    return themeConfig?.code || '';
  } catch (e) {
    return '';
  }
};

export const getCanal = () => getDevicePlatform();

/**
 * En development se pega por IP directa (http://10.5.1.30:PUERTO) desde
 * localhost, o sea cross-origin, y el navegador dispara un preflight OPTIONS.
 * Los servidores :8084 no declaran codParticipante/canal en su
 * Access-Control-Allow-Headers y rechazan ese preflight con 403.
 *
 * Se omiten los headers, NO se vacian: un header con valor '' igual viaja en
 * el Access-Control-Request-Headers y el server lo rechaza igual.
 *
 * En staging y produccion las URLs son relativas (mismo origen) => no hay
 * preflight => los headers viajan normalmente para el tracking del backend.
 */
export const getCustomHeaders = () => (
  process.env.REACT_APP_ENVIRONMENT === 'development'
    ? {}
    : {
      codParticipante: getCodParticipante(),
      canal: getCanal()
    }
);
